const arIframes = document.querySelectorAll('iframe');

for (let i = 0; i < arIframes.length; i++) {
    const iframe = arIframes[i];
    const aspectRatio = getIframeAspectRatio(iframe);

    setIframeAspectRatio(iframe, aspectRatio);
    window.addEventListener('resize', _ => setIframeAspectRatio(iframe, aspectRatio));
}

function setIframeAspectRatio(iFrameElement, ratio) {
    iFrameElement.style.height = Math.min(((iFrameElement.offsetWidth / ratio[0]) * ratio[1]), window.innerHeight * 0.8) + 'px';
}

function getIframeAspectRatio(iframe) {
    let aspectRatio = iframe.dataset.aspectRatio;

    if (aspectRatio) {
        aspectRatio = aspectRatio.split(':');
    }
    else {
        const definedWidth = iframe.getAttribute('width');
        const definedHeight = iframe.getAttribute('height');

        aspectRatio = [1, (definedHeight / definedWidth)];
    }

    return aspectRatio
}